import { render } from "./Missing.vue?vue&type=template&id=52079cce"
const script = {}
script.render = render

export default script